import { createSlice } from '@reduxjs/toolkit';
import FieldNames from '../../defaults/FieldNames.json';
import { setIsBasicFilterActive, setIsCustomFilterActive } from './filterSlice';

export const initialState = {
    customFilters: [],
    activeFilter: null,
    activeFilterState: null,

    // Updated from filterSlice
    isBasicFilterActive: true,
    isCustomFilterActive: false,
};

export const customFilterSlice = createSlice({
    name: 'customFilter',
    initialState,
    reducers: {
        setActiveFilter: (state, action) => {
            state.activeFilterState = action.payload;
            state.activeFilter = action.payload[FieldNames.customFilter.expression];
        },
        addNewFilter: (state, action) => {
            return {
                ...state,
                customFilters: [...state.customFilters, action.payload],
            };
        },
        saveFilterEdit: (state, action) => {
            return {
                ...state,
                customFilters: [
                    ...state.customFilters.filter(
                        (customFilter) => customFilter.filterGuid !== action.payload.filterGuid
                    ),
                    action.payload,
                ],
            };
        },
        removeFilter: (state, action) => {
            return {
                ...state,
                customFilters: [
                    ...state.customFilters.filter(
                        (customFilter) => customFilter.filterGuid !== action.payload.filterGuid
                    ),
                ],
            };
        },
        nukeFilters: (state) => {
            return {
                ...state,
                customFilters: [],
            };
        },
        setCustomFilters: (state, action) => {
            state.customFilters = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setIsBasicFilterActive, (state, action) => {
            state.isBasicFilterActive = action.payload;
        });
        builder.addCase(setIsCustomFilterActive, (state, action) => {
            state.isCustomFilterActive = action.payload;
        });
    },
});

export const {
    setCustomFilters,
    setActiveFilter,
    addNewFilter,
    saveFilterEdit,
    removeFilter,
    nukeFilters,
} = customFilterSlice.actions;

export default customFilterSlice.reducer;
